<a [routerLink]="['/index-details', item.id]" class="index-card-link" aria-label="{{ item.title }}">
  <article class="index-card">
    <!-- <div class="index-card__image-wrapper">
      <img [src]="item.coverImageUrl ?? fallbackImage" [alt]="item.title" (error)="onImageError($event)" loading="lazy" class="index-card__image" />
    </div> -->
    <div class="index-card__content">
      <h3 class="index-card__title" dir="rtl">{{ formattedTitle }}</h3>
      
      <div class="index-card__meta" dir="rtl">
        @if (item.author) {
          <span class="index-card__tag">{{ item.author}}</span>
        }
        
        @if (item.hijriDate) {
          <span class="index-card__tag">{{ item.hijriDate}}</span>
        }
      </div>
    </div>
  </article>
</a>
